// import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import "./Home.css"
import Footer from '../components/Footer';
import { useInView } from 'react-intersection-observer';
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from 'react'; // <-- You were missing useState import!
import { useRef } from 'react';
const videoSources = [
  "/videos/vid1.mp4",
  "/videos/vid2.mp4",
  "/videos/vid3.mp4",
  "/videos/vid4.mp4"
];
function Home() {
  const { ref: productsRef, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

const [currentVideo, setCurrentVideo] = useState(0);
const videoRef = useRef();
  const [active, setActive] = useState(true);
  const videoRefA = useRef();
  const videoRefB = useRef();
  const [showModal, setShowModal] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [productIndex, setProductIndex] = useState(0);
  const [showRecentPosts, setShowRecentPosts] = useState(false);
const [isAnimating, setIsAnimating] = useState(true);
useEffect(() => {
  const interval = setInterval(() => {
    setCurrentVideo(prev => (prev + 1) % videoSources.length);
  }, 9000);

  return () => clearInterval(interval);
}, []);

 useEffect(() => {
  const timeout = setTimeout(() => {
    setActive(prev => !prev);
    const ref = !active ? videoRefA : videoRefB;
    if (ref.current) {
      ref.current.load();
      ref.current.play();
    }
  }, 100); // 100ms buffer to prevent flicker

  return () => clearTimeout(timeout);
}, [currentVideo]);

  // 👇 Correct: useEffect AFTER inView is declared
  useEffect(() => {
    if (inView && showGrid) {
      const timer = setTimeout(() => {
        setShowRecentPosts(true);
      }, 1500); // optional delay to let grid settle

      return () => clearTimeout(timer);
    }
  }, [inView, showGrid]);

  // ...

const products = [
  {
    href: 'products/homes',
img: '360-viz/1.jpg',  // ✅ Just the subfolder & filename
    title: 'Homes',
    desc: 'Step into a home where every detail whispers luxury and every corner reflects you.',
  },
  {
    href: 'products/experience-center',
    img: '/exp.jpg',
    title: 'Experience Centers',
    desc: 'Exalt your real estate marketing with experience centers that breathe your brand’s story...',
  },
  {
    href: 'products/offices',
    img: 'office.jpg',
    title: 'Offices',
    desc: 'Work inside spaces that inspire brilliance, fuel performance, and impact the bottom line...',
  },
  {
    href: 'products/sample',
    img: 'sample.jpg',
    title: 'Sample Apartments',
    desc: 'Visualize the unbuilt—experience your space before it exists...',
  },
];
// const { ref: productsRef, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

const [spotlightIndex, setSpotlightIndex] = useState(0);
const [settledCards, setSettledCards] = useState([]);

useEffect(() => {
  if (!inView) return; // ⬅️ Prevent premature animation

  if (spotlightIndex < products.length) {
    const timer = setTimeout(() => {
      setSettledCards(prev => [...prev, products[spotlightIndex]]);
      setSpotlightIndex(prev => prev + 1);
    }, 2000);
    return () => clearTimeout(timer);
  }
}, [spotlightIndex, inView]); // ⬅️ include inView

const handleNextProduct = () => {
  setProductIndex((prev) => (prev + 1) % products.length);
};
useEffect(() => {
  if (!inView) return;

  if (productIndex < products.length - 1) {
    const timer = setTimeout(() => {
      setProductIndex((prev) => prev + 1);
    }, 1500);
    return () => clearTimeout(timer);
  } else {
    const timer = setTimeout(() => {
      setShowGrid(true);
      setIsAnimating(false); // ⬅️ Add this line
    }, 2000);
    return () => clearTimeout(timer);
  }
}, [productIndex, inView]);

const handlePrevProduct = () => {
  setProductIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
};
const spotlightVariant = {
  initial: { opacity: 0, y: 80, scale: 0.9 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1.05,
    transition: { duration: 0.8, ease: 'easeOut' }
  },
  exit: {
    opacity: 0,
    y: -80,
    scale: 0.8,
    transition: { duration: 0.6, ease: 'easeIn' }
  }
};

const gridCardVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};



const testimonials = [
  {
    video: "https://www.youtube.com/embed/5Lkds1a1D70",
    text: "Association with SmartVizX has helped us hugely. It provides us nearly 20‑25 minutes more with a potential buyer.",
    author: "Ankur Maheshwari, Developer Group, The Economic Times",
  },
  {
    video: "https://www.youtube.com/embed/EvgCICJ-gqI",
    text: "I was amazed to see how they've set out to change the game completely...",
    author: "Chakrit Vorachacreyanan, President, Rockworth",
  },
  {
    video: "https://www.youtube.com/embed/LqRkETnIPC8",
    text: "I am super excited about what SmartVizX is developing...",
    author: "Ashwin Chadha, Sotheby’s International Realty",
  },
];


const [currentIndex, setCurrentIndex] = useState(0);

const handleNext = () => {
  setCurrentIndex((prev) => (prev + 1) % testimonials.length);
};

const handlePrev = () => {
  setCurrentIndex((prev) =>
    prev === 0 ? testimonials.length - 1 : prev - 1
  );
};

const { video, text, author } = testimonials[currentIndex];

  return (
    <>
      <Helmet>
        <title>SmartVizX - Bespoke design, tech-enabled delivery</title>
        <meta
          name="description"
          content="SmartVizX - Bespoke design, tech-enabled delivery"
        />
        <link rel="stylesheet" href="/dist/css/app.min.css" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Ubuntu:300,500"
        />
      </Helmet>

      <Navbar />

     {/* HERO VIDEO SECTION */}
 <div className="hero-video-section">
      <div className="hero-overlay-buttons">
        <a className="quick-links" href="products">
          <div className="box"><span>LEARN MORE</span></div>
        </a>
        <a className="quick-links" href="#" onClick={e => {
          e.preventDefault();
          setShowModal(true);
        }}>
          <div className="box">Connect With Us</div>
        </a>
      </div>

      <div className="video-stack-container">
        <video
          key={currentVideo} // forces re-render for each new video
          ref={videoRef}
          src={videoSources[currentVideo]}
          muted
          playsInline
          autoPlay
          className="video-layer visible"
        />
      </div>
    </div>


{showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <button className="close-btn" onClick={() => setShowModal(false)}>✖</button>
      <h2>Contact Us</h2>
      <form onSubmit={(e) => {
        e.preventDefault();
        const name = e.target.name.value;
        const email = e.target.email.value;
        const phone = e.target.phone.value;
        const message = e.target.message.value;

        const whatsappNumber = "8527417771"; // Replace with your WhatsApp number
        const text = `Hi, I'm ${name}%0AEmail: ${email}%0APhone: ${phone}%0AMessage: ${message}`;
        const url = `https://wa.me/${whatsappNumber}?text=${text}`;

        window.open(url, "_blank");
      }}>
        <input type="text" name="name" placeholder="Name *" required />
        <input type="email" name="email" placeholder="Email *" required />
        <input type="tel" name="phone" placeholder="Phone Number *" required />
        <textarea name="message" placeholder="Your Message" />
        <button type="submit">Send Message</button>
      </form>
    </div>
  </div>
)}


{/* COMPANY TEXT SECTION */}
<div className="company-text-section">
  <div className="container">
    <p>We design and build innovative spaces using proprietary immersive technology ensuring that performance meets emotion. From flagship offices to experience centers and bespoke residences, we create environments that embody a brand’s story and elevates how people feel, move and connect within them. Every space is imagined with intent and delivered with precision. We turn vision into form and form into lived experience. 

 </p>
    <h3>This is where the magic starts</h3>
    <div className="sliding-highlight-bar">
  <div className="sliding-text-track">
    <div className="sliding-text">
      100+ Happy Customers • 10 Million+ Sq. Ft. Designed & Delivered • 250+ Immersive Collaborations • 
    </div>
    <div className="sliding-text">
      100+ Happy Customers • 10 Million+ Sq. Ft. Designed & Delivered • 250+ Immersive Collaborations • 
    </div>
  </div>
</div>

  </div>

  {/* CLIENT LOGOS */}
<div className="client-logo-slider">
  <div className="clogo-track">
    {[
      'AURealestate.png', 'FILATEX.png', 'Indigo.png', 'interOCEAN.jpg',
      'M3M.png', 'Quikrlogo.png', 'Smartworld.jfif', 'SmartWorldonedxp.png',
      'quint.png', 'TREVOCLogo.jpg', 'Upgrad.png',
    ]
    .concat([
      'AURealestate.png', 'FILATEX.png', 'Indigo.png', 'interOCEAN.jpg',
      'M3M.png', 'Quikrlogo.png', 'Smartworld.jfif', 'SmartWorldonedxp.png',
      'thequintlogo.png', 'TREVOCLogo.jpg', 'Upgrad.png',
    ])
    .map((filename, idx) => (
      <div className="clogo" key={idx}>
        <img src={`/ourproducts/${filename}`} alt={`logo-${idx}`} />
      </div>
    ))}
  </div>
</div>


</div>
<div className="combined-section" >
{/* <div className="combined-section"> */}
  {/* <div className="bg-video-wrapper">
    <video
      autoPlay
      muted
      loop
      playsInline
      className="bg-video"
    >
      <source src="/backvid.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div> */}

  {/* Your existing combined-section content below */}
  <div className="your-inner-content">
    {/* ...Products Section, etc... */}
  </div>
{/* </div> */}

      {/* PRODUCTS SECTION */}
<div className="products-section" ref={productsRef} >
  {/* Sliding GIF Background */}
  {/* <div className="gif-background-wrapper">
    <img src="/design/gif.gif" alt="Decorative Animation" className="sliding-gif" />
  </div> */}

  <h3>Our Work</h3>
<div className="products-wrapper">
<div
  className="spotlight-stage"
  style={{ height: isAnimating ? '700px' : '1022px', transition: 'height 0.5s ease' }}
>
    <AnimatePresence mode="wait">
      {!showGrid ? (
        <motion.div
          key={products[productIndex].title}
          className="spotlight-card"
          variants={spotlightVariant}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <a href={products[productIndex].href}>
<img
  src={`/img/products/${products[productIndex].img}`}
  alt={products[productIndex].title}
/>
            <h4 className="text-center">{products[productIndex].title}</h4>
            <p>{products[productIndex].desc}</p>
          </a>
        </motion.div>
      ) : (
        <motion.div className="final-grid" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          {products.map(({ href, img, title, desc }, i) => (
            <div className="card" key={i}>
              <a href={href}>
                <img src={`/img/products/${img}`} alt={title} />
                <h4 className="text-center">{title}</h4>
                <p>{desc}</p>
              </a>
            </div>
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
</div>

</div>




      {/* RECENT POSTS SECTION */}
   {/* RECENT POSTS SECTION */}
{/* RECENT POSTS SECTION */}

{showRecentPosts && (
  <div className="recent-posts-section container">
    <h2 className="text-center">Recent Posts</h2>

    <div className="blog-widget">
      <div className="posts-list">
        {[
          {
            link: 'blog/virtual-reality-design-software-and-vr-aided-build.php',
            title:
              'Virtual Reality Design Software & VR Aided Build – Powerful VR Based Solutions That Will Change The Way Projects Are Built',
            author: 'Gautam Tewari',
          },
          {
            link: 'blog/viviz-vr-harnessing-the-power-of-mobile-vr.php',
            title:
              'ViViz VR - Harnessing the power of Mobile Virtual Reality Solutions for business',
            author: 'Gautam Tewari',
          },
          {
            link: 'blog/virtual-reality-empowering-consumers.php',
            title: 'Virtual Reality Empowering Consumers',
            author: 'Gautam Tewari',
          },
          {
            link: 'blog/how-can-technology-save-environment.php',
            title:
              'How Can Technology Save Environment And Give Our Planet A Fresh Lease of Life !',
            author: 'Gautam Tewari',
          },
        ].map(({ link, title, author }, i) => (
          <a key={i} className="article summary box" href={link}>
            <article>
              <p className="heading">{title}</p>
              <p className="author">Posted by {author}</p>
            </article>
          </a>
        ))}
      </div>

      <div className="view-more-link">
        <a href="/blog">View Our Blog</a>
      </div>
    </div>
  </div>
)}

</div>


<Footer />



    </>
  );
}

export default Home;
